module.exports = __webpack_public_path__ + "assets/img/6e585114133589032870802fdd228246.png";